import { memo } from 'react';
import { Caption1, makeStyles, tokens } from '@fluentui/react-components';
import { Filter20Regular } from '@fluentui/react-icons';

import DashboardFilterPicker from './DashboardFilterPicker';
import type { TSparseItem } from '@modules/items';

const useStyles = makeStyles({
  toolbar: {
    display: 'grid',
    gridTemplateColumns: 'minmax(280px, 420px)',
    '@media (max-width: 720px)': {
      gridTemplateColumns: '1fr',
    },
  },
  fieldLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
    marginBottom: tokens.spacingVerticalXS,
    color: tokens.colorNeutralForeground2,
  },
  picker: {
    width: '100%',
  },
});

type TProps = {
  rootOptions: TSparseItem[];
  selectedRootIds: string[];
  onSelectedRootIdsChange: (rootIds: string[]) => void;
};

const DashboardFilterBar = ({ rootOptions, selectedRootIds, onSelectedRootIdsChange }: TProps) => {
  const classes = useStyles();

  return (
    <div className={classes.toolbar} aria-label="Dashboard filters">
      <div>
        <Caption1 className={classes.fieldLabel}>
          <Filter20Regular />
          Filter by product
        </Caption1>
        <DashboardFilterPicker
          options={rootOptions}
          selectedRootIds={selectedRootIds}
          onChange={onSelectedRootIdsChange}
          className={classes.picker}
        />
      </div>
    </div>
  );
};

export default memo(DashboardFilterBar);
